function createFallbackStorage() {
    let store
    return {
        getStore() {
            return store
        },
        run(value, callback, ...args) {
            const previousStore = store
            store = value
            try {
                return callback(...args)
            } finally {
                store = previousStore
            }
        },
    }
}

function resolveAsyncLocalStorage() {
    if (typeof process === "undefined") {
        return undefined
    }
    const { getBuiltinModule } = process
    if (typeof getBuiltinModule !== "function") {
        return undefined
    }
    return getBuiltinModule("node:async_hooks")?.AsyncLocalStorage ?? getBuiltinModule("async_hooks")?.AsyncLocalStorage
}

const AsyncLocalStorage = resolveAsyncLocalStorage()
const storageInstance = AsyncLocalStorage ? new AsyncLocalStorage() : createFallbackStorage()
const asyncLocalStorage = (globalThis.storage ??= storageInstance)
export { asyncLocalStorage }
